import { useQuery } from '@tanstack/react-query'

import * as walletServices from '../walletServices'
import { CryptoAddressPayload } from '../walletTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetOrCreateCryptoAddress = (payload: CryptoAddressPayload) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CRYPTO_ADDRESSES, payload],
    queryFn: () => walletServices.getOrCreateCryptoAddress(payload),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: Boolean(payload?.currency && payload?.network_code),
  })
}
